export const WEBSITES = [
    {
        id: 1,
        name: "Meet Globalbot",
        src: "images/GlobalBot.png",
        alt: "screenshot of meet globalbot website",
        desc: "Meet Global Bot is a marketing site for generating sales leads. This site was created in Bootstrap 4, JavaScript, JQuery and PHP.",
        // link: "http://meetglobalbot.com",
        link: "https://globalbot.riverdaleglobal.com",
        btnTxt: "Visit the Site"
    },
    {
        id: 2,
        name: "React Native App",
        src: "images/covid-app.png",
        alt: "screenshot of covid app",
        desc: "Nucamp React Native project created with my classmate Hiwot using data from a COVID api and react-native-chart-kit for visual data display.",
        link: "https://github.com/jgilday01/react-native-project",
        btnTxt: "View the Code"
    },
    {
        id: 3,
        name: "Muffins, Meatballs & Mules",
        src: "images/React-Project.png",
        alt: "screenshot of MMM react project",
        desc: "Nucamp bootcamp project initially created in Bootstrap 4 and then converted over to REACT. This project utilizes Redux for state management.",
        // page: "https://jgilday01.github.io/react-project",
        link: "https://github.com/jgilday01/react-project",
        btnTxt: "Visit the Site"
    },
    {
        id: 4,
        name: "Gaming Tracker",
        src: "images/Gaming-Tracker.png",
        alt: "screenshot of GT react project",
        desc: "React project co-created with Warren Savage. This project uses a Slim api backend to store user data and React on the frontend.",
        link: "https://gamingtracking.net",
        btnTxt: "Visit the Site"
    },
];
